/** @jsxImportSource @emotion/react */

import { MinusIcon } from 'lucide-react';
import { BOARD_MASTER_NEGATIVE_COLOR } from 'modules/board-master/domain/constants/colors';
import { ButtonHTMLAttributes } from 'react';
import EmptyButton from 'ud-ui/components/empty-button';
import { SmoothChangeColorCss } from '../styles';

type Props = ButtonHTMLAttributes<HTMLButtonElement>;

function Minus(props: Props) {
  const { disabled } = props;

  return (
    <div
      className={'flex-center'}
      css={SmoothChangeColorCss}
      style={{
        background: disabled ? `${BOARD_MASTER_NEGATIVE_COLOR}33` : BOARD_MASTER_NEGATIVE_COLOR,
        padding: 2,
        borderRadius: 8,
        height: 'fit-content',
      }}
    >
      <EmptyButton
        {...props}
        css={SmoothChangeColorCss}
        disabledColor="#FFFFFF66"
        color={'white'}
        icon={<MinusIcon color={'currentColor'} size={56} strokeWidth={2} />}
      />
    </div>
  );
}

export default Minus;
